module.exports = __webpack_public_path__ + "img/stock3.928a95e5.png";